export enum MonitoringTags {
  SEGUIMIENTO_COVID19 = 'SEGUIMIENTO_COVID19',
  DENGUE = 'DENGUE',
  CHRONIC = 'CHRONIC'
}
